export default {
  computed: {
    isNewDesignTheme() {
      return window.location.host.indexOf('.com') !== -1;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/newDesignDetector.js